import React from "react";
import { Helmet } from "react-helmet";

// Utility to build ItemList schema for category/listing pages
function buildItemListSchema(products: { url: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: products.map((product, idx) => ({
      "@type": "ListItem",
      position: idx + 1,
      url: product.url
    }))
  };
}

// Utility to build Product schema for product detail pages
function buildProductSchema(product: any) {
  if (!product) return null;
  const {
    name,
    image,
    description,
    sku,
    mpn,
    brand,
    canonicalUrl,
    price,
    availability
  } = product;
  if (
    !name ||
    !image ||
    !description ||
    !sku ||
    !brand ||
    !canonicalUrl ||
    !price ||
    !availability
  ) {
    return null; // Required fields missing
  }
  const schema: any = {
    "@context": "https://schema.org/",
    "@type": "Product",
    name,
    image: Array.isArray(image) ? image[0] : image,
    description,
    sku,
    mpn: mpn || sku,
    brand: {
      "@type": "Brand",
      name: brand
    },
    offers: {
      "@type": "Offer",
      url: canonicalUrl,
      priceCurrency: "AED",
      price,
      availability: `https://schema.org/${availability}`,
      itemCondition: "https://schema.org/NewCondition"
    }
  };
  return schema;
}

// Products or product
const SchemaMarkup = ({
  products,
  product
}: {
  products?: { url: string }[];
  product?: any;
}) => {
  let structuredData;
  if (products) {
    structuredData = buildItemListSchema(products);
  } else if (product) {
    structuredData = buildProductSchema(product);
  }

  if (!structuredData) return null;

  return (
    <Helmet>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
    </Helmet>
  );
};

export default SchemaMarkup;
